import React, { useState, useEffect } from 'react';
import { CONFIG } from '../config';

const ProfilePage = ({ activeEventId, availableEvents, onEventSwitch }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const fetchUserInfo = async () => {
    try {
      const response = await fetch(`${CONFIG.apiBaseUrl}/user-info`, {
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch user info');
      }

      const data = await response.json();
      setUserInfo(data);
    } catch (err) {
      console.error('Error fetching user info:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="admin-page">
        <h2 className="page-title">Profile</h2>
        <div className="loading-message">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-page">
        <h2 className="page-title">Profile</h2>
        <div className="error-message">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <h2 className="page-title">Profile</h2>

      <div className="admin-content">
        <div className="user-info-box">
          <h3>Your Information</h3>
          <div className="info-row">
            <strong>Name:</strong> {userInfo?.name}
          </div>
          <div className="info-row">
            <strong>Event Access:</strong> {availableEvents && availableEvents.length > 0
              ? availableEvents.map(ev => ev.event_name).join(', ')
              : 'None'}
          </div>
        </div>

        {availableEvents && availableEvents.length > 1 && (
          <div className="user-info-box">
            <h3>Active Event</h3>
            <div className="info-row">
              <label htmlFor="event-select"><strong>Switch Event:</strong></label>
              <select
                id="event-select"
                className="profile-event-select"
                value={activeEventId || ''}
                onChange={(e) => onEventSwitch(e.target.value)}
              >
                {availableEvents.map(ev => (
                  <option key={ev.event_id} value={ev.event_id}>
                    {ev.event_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfilePage;
